import React from 'react';

const  IconGlobal= () => {

    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <circle cx="16" cy="16" r="15.5" stroke="currentColor"/>
            <path d="M0.5 16.5H31.5M3.5 7C3.5 7 7.5 11.5 16 11.5C24.5 11.5 28.5 7 28.5 7" stroke="currentColor"/>
            <path d="M3.5 25.5C3.5 25.5 7.5 21 16 21C24.5 21 28.5 25.5 28.5 25.5" stroke="currentColor"/>
            <line x1="16" y1="1" x2="16" y2="31" stroke="currentColor"/>
        </svg>
    )

}

export default IconGlobal;
